import React from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { formatDuration } from '../../components/FormatDuration';

const VideoPreview = ({ videoData, isLoading }) => {
  if (isLoading) {
    return (
      <div className="w-full mx-auto sm:max-w-md">
        <div className="flex items-center justify-center mt-20">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#4fa94d"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      </div>
    );
  }

  if (!videoData) {
    return null;
  }

  return (
    <div className="w-full mx-auto sm:max-w-md">
      <div className="mt-10">
        <div className="flex items-center justify-center my-4">
          <img
            className="border border-red-700 max-w-sm rounded bg-white p-1 dark:border-neutral-700 dark:bg-neutral-800"
            width={400}
            src={videoData.snippet.thumbnails.high.url}
            alt="Video Thumbnail"
          />
        </div>
        <h2 className="text-center font-medium text-xl pl-10 pr-10 pb-3">
          {videoData.snippet.title}
        </h2>
        <h2 className="text-center font-medium text-xl text-red-500">
          {formatDuration(videoData.contentDetails.duration)}
        </h2>
      </div>
    </div>
  );
};

export default VideoPreview;
